/**
 * @generated SignedSource<<ed572fd50509540ab5442d282a9a8e04>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type NumberCell450BadPattern$data = {
  readonly id: string;
  readonly lazyIsEditableInIssueView?: boolean | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"number_issueFieldNumberInlineEditFull_NumberInlineEditViewWithIsEditable_fragmentRef">;
  readonly " $fragmentType": "NumberCell450BadPattern";
};
export type NumberCell450BadPattern$key = {
  readonly " $data"?: NumberCell450BadPattern$data;
  readonly " $fragmentSpreads": FragmentRefs<"NumberCell450BadPattern">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "isInlineEditingEnabled"
    }
  ],
  "kind": "Fragment",
  "name": "NumberCell450BadPattern",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "id"
    },
    {
      "condition": "isInlineEditingEnabled",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "kind": "ClientExtension",
          "selections": [
            {
              "kind": "ScalarField",
              "name": "lazyIsEditableInIssueView"
            }
          ]
        }
      ]
    },
    {
      "kind": "FragmentSpread",
      "name": "number_issueFieldNumberInlineEditFull_NumberInlineEditViewWithIsEditable_fragmentRef"
    }
  ],
  "type": "JiraNumberField"
};

(node as any).hash = "d624c19b57a0235b8064881101281415";

export default node;
